import cn from 'classnames';
import React, {useState} from 'react';
import ReactQuill from 'react-quill';

import {QuillToolbar} from 'components/rich-text';
import {TComponentClassNames} from 'shared/types';

interface IRichRendererProps {
    value?: string;
    classNames?: TComponentClassNames;
}

export const RichTextRenderer = ({
    value,
    classNames,
    ...props
}: IRichRendererProps) => {
    const {wrapperClassName} = classNames ?? {};

    const [text, setText] = useState(value);
    const handleChange = (html: string) => {
        setText(html);
    };

    return (
        <div className={cn('rich-text-renderer', wrapperClassName)}>
            <ReactQuill
                theme="snow"
                modules={{
                    toolbar: {container: '#renderer-toolbar'},
                }}
                value={text}
                onChange={handleChange}
                {...props}
                readOnly
            />
            <QuillToolbar
                disabled
                toolbarHtmlId="renderer-toolbar"
            />
        </div>
    );
};
